import { Component, OnInit, Input, Output, EventEmitter, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { TreeNode, TreeOptions } from '@mydocma/component-library/src/lib/tree';
import { Structure } from '../structure.model';
import { MediatorService } from '@mydocma/core';
import { CoEvent, CoEventService } from '@mydocma/co';

@Component({
  selector: 'mydocma-structure-tree',
  templateUrl: './structure-tree.component.html',
  styleUrls: ['./structure-tree.component.scss']
})
export class StructureTreeComponent implements OnInit {

  @Input() treeOptions: TreeOptions;

  @Input() structuresTree;

  @Input() selectedStructureTreeNode;

  @Output()
  structureClick = new EventEmitter<Structure>();

  @ViewChild('mydocmaTreeElement', {static: true}) mydocmaTreeElement: ElementRef

  highlightClass = 'mydocma-tree-search-highlight';
  constructor(private readonly mediatorService: MediatorService, private readonly CoEventService: CoEventService) {
  }

  ngOnInit(): void {
    if ( typeof(this.treeOptions) === 'undefined' ) {
      this.treeOptions = {
          // collapseAllTopLevel: 1,
          suppressChildrenCount: true,
          // getNodeId: (data) => data.Id,
          getNodeChildren: (node) => node.data.children,
          getNodeInfo: (node) => {
            return {
              text: `${node.data.name} - ${node.data.desc}`,
              expanded: true,
            }
          },
          onReady: (treeService) => {
            this.CoEventService.emit(CoEvent.StructureTreeReady, treeService);
          }
      };
    }
  }

  public onClick(node: TreeNode) {
    if (node) {
      this.structureClick.emit(node.data);
    }
}

}
